import React, { useEffect } from 'react';

import { JsBridge, HELPER } from 'utils';
import { Button } from '../../components';

import config from './TncFormPage.page.config';
import text from './TncFormPage.page.translation';
import './TncFormPage.page.style.less';

const TncFormPage = ({
  history,
  intl: { formatMessage, locale },
  tnc,
  setAgreeTnc,
}) => {
  useEffect(() => {
    JsBridge.setTitle(formatMessage(text.title));
  }, []);

  const _renderBody = () => (
    <div
      className="body"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: HELPER.decodeHtml(tnc[locale]) }}
    />
  );

  const _onAgreeTncButtonClicked = () => {
    setAgreeTnc();
    history.goBack();
  };

  const _renderFooter = () => {
    const buttonClassName = `primary full`;
    return (
      <div id="footer-tnc-form-page" className="footer">
        <Button addClass={buttonClassName} action={_onAgreeTncButtonClicked}>
          {formatMessage(text.btnContinue)}
        </Button>
      </div>
    );
  };

  return (
    <div id="tnc-form-page">
      {_renderBody()}
      {_renderFooter()}
    </div>
  );
};

TncFormPage.displayName = config.displayName;
TncFormPage.defaultProps = config.defaultProps;
TncFormPage.propTypes = config.propTypes;

export default TncFormPage;
